module.exports = __webpack_public_path__ + "img/1F1ED-1F1FA.d404033c.svg";